<ng-template [ngIf]="infoPanel">
  <div class="news-detail-container">

    <div class="news-image" id="header">
      <img [src]="imageUrl" alt="news image" loading="lazy" />
    </div>

    <div class="header-btn" id="headerBtn" *ngIf="showHeader">
      <span [ngClass]="{'isSticky-btn': isSticky , 'nonSticky-btn': !isSticky}" (click)="onClickBack()"><i
          class="icon-chevron-left"></i></span>
      <h1 id="title" [innerHtml]="title"></h1>
      <span [ngClass]="{'isSticky-btn': isSticky, 'nonSticky-btn': !isSticky}" (click)="showShare = true"><i
          class="icon-share"></i></span>
    </div>

    <div class="news-content">
      <h1 class="title" [innerHtml]="title"></h1>
      <h2 [innerHtml]="subtitle"></h2>

      <hr>

      <p [innerHtml]="content"></p>
    </div>
  </div>
</ng-template>

<p-dialog position="bottom" [(visible)]="showShare" [modal]="false" [dismissableMask]="true" [blockScroll]="true"
  *ngIf="showShare" styleClass="fullScreen-dialog fullScreenWithBlack-dialog">
  <app-social-share [title]="title" [description]="subtitle" [url]="infoPanel.infoUrl" (onClickAction)="showShare = false"></app-social-share>
</p-dialog>
